/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 **/


 /* ------------------------------------------------------------------------------------------------------------
 * MANAGE ADD TO CART FOR AUTOMATIC DISCOUNTS AS DEFINED IN THEME SETTINGS
 * ------------------------------------------------------------------------------------------------------------*/

function reinitRecos() {
      const swiperReco = new Swiper('.recoSwiper', {
          // Optional parameters
          loop: true,
          rewind:true,
          slidesPerView: 1.25,     
          spaceBetween: 12,       
          centeredSlides: true,

          pagination:false,
          navigation: {
            nextEl:".swiper-button-next",
            prevEl:".swiper-button-prev"
          },
          hashNavigation:false,
        });   
}

document.addEventListener('cart:refresh', function(event) {
  // Refresh reco swiper carrousel after reload
  setTimeout(function(){
    reinitRecos();
  }, "1800");
});

/* Listen to any button click */

document.addEventListener('click', (event) => {
  //console.log(document.getElementById('swipermini-cart').classList);
  setTimeout(function(){    
    if (!document.getElementById('swipermini-cart').classList.contains('swiper-initialized')) {    
      reinitRecos();
    }
  }, "2000");
})



 /* ------------------------------------------------------------------------------------------------------------
 * ITEM DATAS STORED FOR GTM CUSTOM PIXEL AT CHECKOUT
 * ------------------------------------------------------------------------------------------------------------*/

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function buildItems() {
  const items = document.querySelectorAll("line-item");
  var storeItems = [];
  Array.from(items).forEach((item) => {
      //console.log(item.dataset.sku);
      var itemDatas = {
        sku: item.dataset.sku.replace(/ /g,"_"),
        category: item.dataset.category.toLowerCase().replace(/ /g,"_"),
        fullPrice: item.dataset.fullprice
      };
      storeItems.push(itemDatas);


      setCookie('items',JSON.stringify(storeItems),30)
      //document.cookie = "items=" + JSON.stringify(storeItems); + ";";     
  })  
  //console.log(storeItems);

}

// QUICK CODE TO REFRESH COOKIE FOR CUSTOM PIXEL
document.addEventListener('cart:updated', function(event) {
    buildItems(); 
});

document.addEventListener('cart:refresh', function(event) {
    buildItems(); 
});

window.addEventListener("load", (event) => {
    buildItems();  
});

let checkoutBtn = document.querySelector('#mini-cart .checkout-button');
  checkoutBtn.addEventListener("click", function (e) {
      buildItems();    
  });


let checkoutForm = document.querySelector('#mini-cart-form');
checkoutForm.addEventListener("submit", (event) => {
    buildItems();     
});







 /**
 * ------------------------------------------------------------------------------------------------------------
 * SHOW CAROUSELS ONLY WHEN THEY'RE LOADED AND READY
 * ------------------------------------------------------------------------------------------------------------*/
/*this.addEventListener("flickity:ready", showCarousel());

function showCarousel() {
  setTimeout(() => {
    document.querySelector('body').classList.add('fl-ready');
  }, "500");
}*/

//this.addEventListener("flickity:ready", setCarHeight());
//this.addEventListener("flickity:ready", setCarCartHeight());

/*function setCarHeight() {   
  setTimeout(function(){
    const items = document.querySelectorAll('.f-block'); 
    console.log(items);
    items.forEach(item => {
      item.style.height = '100%';
    });
  }, 500);
}*/
/*
function setCarCartHeight() {   
  setTimeout(function(){
    const items = document.querySelectorAll('.f-block--cart'); 
    console.log(items);
    items.forEach(item => {
      item.style.height = '100%';
    });
  }, 2500);
}*/


/*window.addEventListener("load", function(event) {
  setCarHeight();
})*/

 /**
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * 
 /**
 * ------------------------------------------------------------------------------------------------------------
 * CLOSE MOBILE MENU WHEN CLICKED LINK IS ACTIVE
 * ------------------------------------------------------------------------------------------------------------*/
  //let activeLinks = document.querySelectorAll('#mobile-menu-drawer a.active');

  document.querySelectorAll('#mobile-menu-drawer a.active').forEach(function(node) {
     node.addEventListener("click", function (e) {
      var target = node.href;
      if (target.indexOf("#") > -1) {
        alert("your url contains #");
      } 
      e.preventDefault();
      document.getElementById('mobile-menu-drawer').open = false;
     });
  });

  document.querySelectorAll('#mobile-menu-drawer a.anchorLink').forEach(function(anchor) {
     anchor.addEventListener("click", function (e) {
      document.getElementById('mobile-menu-drawer').open = false;
     });    
  });
  


 /* ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

// PRODUCT SPECS//
const tabs = document.querySelectorAll("[data-target]"),
  tabContents = document.querySelectorAll("[data-content]");

tabs.forEach((tab) => {
  tab.addEventListener("click", () => {
    const target = document.querySelector(tab.dataset.target);

    tabContents.forEach((tc) => {
      tc.classList.remove("is-active");
    });
    target.classList.add("is-active");

    tabs.forEach((t) => {
      t.classList.remove("is-active");
    });
    tab.classList.add("is-active");
  });
});

// COLLECTION LINKS //
const ratio = 0.6;
const spies = document.querySelectorAll("[data-spy]");

let observer = null;
const activate = function (e) {
  const t = e.getAttribute("id");
  const n = document.querySelector(`a[href="#${t}"]`);
  if (null === n) return null;
  n.parentElement.querySelectorAll(".active").forEach((e) => e.classList.remove("active"));
  setTimeout(() => {
    n.scrollIntoViewIfNeeded({ block: "start" });
  }, 700);
  n.classList.add("active");
};

const callback = (e) => {
  e.forEach((e) => {
    e.isIntersecting && activate(e.target);
  });
};

const debounce = function (e, t) {
  let n;
  return function () {
    let i = arguments,
      r = this;
    clearTimeout(n),
      (n = setTimeout(function () {
        e.apply(r, i);
      }, t));
  };
};

if (spies.length > 0) {
  const t = Math.round(0.6 * window.innerHeight);
  const observer = new IntersectionObserver(callback, {
    rootMargin: `-${window.innerHeight - t - 1}px 0px -${t}px 0px`
  });

  null !== observer && spies.forEach((spie) => observer.unobserve(spie));

  spies.forEach((spie) => {
    observer.observe(spie);
    const t = spie.getAttribute("id");
    const anchor = document.querySelector(`a[href="#${t}"]`);
    //const anchor = document.querySelector('a');
    anchor.addEventListener("click", (e) => {
      e.preventDefault();
      setTimeout(() => {
        window.scrollTo({ top: spie.getBoundingClientRect().top + window.pageYOffset + -140, behavior: "smooth" });
      });
    });
  });

  let e = window.innerHeight;

  window.addEventListener(
    "resize",
    debounce(function () {
      window.innerHeight !== e && (observe(spies), (e = window.innerHeight));
    }, 500)
  );
}

window.customElements.define(
  "view-item",
  class ProductLink extends HTMLElement {
    connectedCallback() {
      sendDataLayer(this, "view_item", Number((this.getAttribute("data-value") || 0) / 100));
    }
  }
);

window.customElements.define(
  "ga-rfc",
  class GaRfc extends HTMLElement {
    connectedCallback() {
      this.addEventListener("click", this.onClick);
    }
    onClick = () => {
      sendDataLayer(
        this,
        "remove_from_cart",
        Number(this.getAttribute("data-compare_at_price") || this.getAttribute("data-price")) / 100
      );
    };
  }
);

window.customElements.define(
  "ga-atc",
  class GaAtc extends HTMLElement {
    connectedCallback() {
      this.addEventListener("click", this.onClick);
    }

    onClick = () => {
      sendDataLayer(this, "add_to_cart", Number(this.getAttribute("data-price")) / 100);
    };
  }
);

window.customElements.define(
  "ga-cart-summary",
  class GaCartSummary extends HTMLElement {
    connectedCallback() {
      this.addEventListener("open-side-cart", this.onOpen);
      if (window.location.pathname === "/cart") {
        setTimeout(this.onOpen, 200);
      }
    }

    onOpen = () => {
      const items = Array.from(this.querySelectorAll("ga-cart-summary-item")).map((el) => makeDataLayerItem(el));
      console.log(items);
      sendDataLayer(items, "view_cart", Number(this.getAttribute("data-price") / 100));
    };
  }
);
window.customElements.define("ga-cart-summary-item", class GaCartSummaryItem extends HTMLElement {});

window.customElements.define(
  "ga-list-summary",
  class GaListSummary extends HTMLElement {
    connectedCallback() {
      setTimeout(this.onView, 200);
    }
    onView = () => {
      const item_list_name = this.getAttribute("data-item_list_name") || null;
      const items = Array.from(this.querySelectorAll("product-item")).map((element) =>
        makeDataLayerItem(element, item_list_name)
      );
      sendDataLayer(items, "view_item_list");
    };
  }
);



